
export default {
  name: "UserSubscriptionInfo",
  props: {
    subscriptionConfig: {
      type: Object,
      required: false,
    },
  },
};
